import axios from "axios";
import http from "./helpers/httpInterceptor";

const dataInstance = axios.create({
  baseURL: process.env.VUE_APP_LOGIN_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  // withCredentials: true,
});

const state = () => ({
  userInfo: localStorage.getItem("session_login") ? JSON.parse(localStorage.getItem("session_login")) : {},
  userLogout: null,
  isAuthenticated: localStorage.getItem("session_login") ? true : false,
  loading: false,
});

// mutations
const mutations = {
  USER_LOGIN(states, data) {
    states.userInfo = data;
    states.isAuthenticated = true;
  },
  USER_LOGOUT(states) {
    states.userInfo = {};
    states.isAuthenticated = false;
  },
  LOADING_REQUEST(states) {
    states.loading = !states.loading;
  },
  RESET_LOADING(state) {
    state.loading = false;
  },
};

// actions
const actions = {
  userLogin({ commit }, payload) {
    return dataInstance
      .post("/login", payload)
      .then((res) => {
        // res.data.menuTabs[0].items[0].children.push({
        //   children: null,
        //   icon: null,
        //   label: null,
        //   mainState: null,
        //   name: "Special Explanation",
        //   state: "/timesheet/special-explanation",
        //   type: null,
        // });
        localStorage.setItem("session_login", JSON.stringify({ access_token: res.data.access_token, userName: res.data.userName }));
        const r = () => Math.floor(256 * Math.random());
        localStorage.setItem("color_avatar", `rgb(${r()}, ${r()}, ${r()})`);
        commit("USER_LOGIN", res.data);
        return res.data;
      })
      .catch((error) => {
        commit("USER_LOGIN", "success");
        throw error;
      });
  },

  userLogout({ commit }) {
    return new Promise((resolve) => {
      commit("USER_LOGOUT");
      localStorage.removeItem("session_login");
      localStorage.removeItem("color_avatar");
      sessionStorage.clear();
      resolve();
    });
  },
  loadingRequest({ commit }) {
    return new Promise((resolve) => {
      commit("LOADING_REQUEST");
      resolve();
    });
  },
  getUserDetail({ commit }, payload) {
    return http
      .get(`/tms/user/detail?username=${payload}`)
      .then((res) => {
        if (res.status === 200) {
          commit("USER_LOGIN", res.data);
        } 
        return res
      })
      .catch((error) => {
        return error.response
      });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
